import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@interticket/core';
import { ICardDenomination } from './../../core/interfaces/card/card-denomination.interface';

@Pipe({
  name: 'currencies',
})
export class CurrenciesPipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) { }

  transform(values: ICardDenomination[], separator = '\n'): string {
    const currencyPipe = new CurrencyPipe(this.translate.currentLang);
    return values?.map(valueItem => currencyPipe.transform(valueItem.value, valueItem.currency)).join(separator) || '';
  }

}
